export default function(theme) {
  return {

    root: {
      width: '70%',
      minWidth: theme.spacing.unit * 50
    },

    filters: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: `${theme.spacing.unit}px 0`,
      margin: `0 -${theme.spacing.unit}px`
    },

    filter: {
      width: '100%',
      margin: `0 ${theme.spacing.unit}px`
    },

    bold: {
      fontWeight: 'bold'
    },

    container: {
      width: '100%',
      textAlign: 'left',
      marginBottom: `-${theme.spacing.unit * 5}px`
    }

  }
}



// WEBPACK FOOTER //
// ./src/styles/components/KeysList.js